export default __webpack_public_path__ + "static/media/Footer3_white.ba01c610.png";